import { Fragment } from "react";
import "./BreadCrumb.css";

const BreadCrumb = ({title, currentpageTitle}) => {
  return (
    <Fragment>
      <div className="breadcrumb-style">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="breadcrumb-text text-center">
              <h1>{title}</h1>
              <p>
                <a href="https://kairaatechserve.com/">Home</a> / {currentpageTitle}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default BreadCrumb;
